// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2le5p","icon":"SortAdornment_icon__1FzKE","up":"SortAdornment_up__2F9g0","down":"SortAdornment_down__1SWeR","active":"SortAdornment_active__1niX0"};